import { MobXProviderContext } from "mobx-react";
import React from "react";

/**
 *
 */
export const useControllers = <T extends { [key: string]: any }>(): T =>
  React.useContext(MobXProviderContext) as T;
